module.exports = __webpack_public_path__ + "img/62.40a2fb3f.jpg";